import './SkillsIcons.css';

function SkilsIcons() {
 return (
    <section className="skills-section my-skills " id="skills">
        <h1 className="text-skills" data-aos="slide-up">Skills</h1>
        <img src="./skills_wheel.svg" alt="Skills" data-aos="zoom-out"/>
    </section>

 );

}
export default SkilsIcons;